import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import FormContainer from "../Components/FormContainer";
import Loader from '../Components/Loader';
import { useLoginMutation } from '../slices/usersApiSlice';
import { setCredentials } from "../slices/authSlice";
import { toast } from 'react-toastify';
import { startGuestCheckout, setCartOwner } from '../slices/cartSlice';

const LoginScreen = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [login, { isLoading }] = useLoginMutation();

    const { userInfo } = useSelector((state) => state.auth);

    const { search } = useLocation();
    const sp = new URLSearchParams(search);
    const redirect = sp.get('redirect') || '/';
    const guestTarget = '/guest-shipping';

    useEffect(() => {
        if (userInfo) {
            navigate(redirect);
        }
     }, [userInfo, redirect, navigate]);

    const submitHandler = async (e) => {
        e.preventDefault()
        const emailNorm = String(email).trim().toLowerCase();
    if (!emailNorm) return toast.error('Please enter your email');
    if (!password) return toast.error('Please enter your password');
    try {
      const res = await login({ email: emailNorm, password }).unwrap();
      dispatch(setCredentials({ ...res }));
      // set cart owner to the new user; clears old shipping/guest info
     if (res && res._id) dispatch(setCartOwner(res._id));
      navigate(redirect);
    } catch (err) {
      const msg = err?.data?.message || err?.error || 'Sign in failed';
      toast.error(msg);
    }
     }
    
// Guest checkout handler
    const handleGuestCheckout = () => {
      // mark cart as guest flow and go to unprotected guest shipping route
      dispatch(startGuestCheckout());
      navigate(guestTarget);
    };

  return (
    <FormContainer>
       <h1>Sign In</h1>

       <Form onSubmit={submitHandler}>
            <Form.Group controlId='email' className="my-3">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                type='email'
                placeholder='Enter email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                ></Form.Control>
            </Form.Group>

            <Form.Group controlId='password' className="my-3">
                <Form.Label>Password</Form.Label>
                <Form.Control
                type='password'
                placeholder='Enter password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                ></Form.Control>
            </Form.Group>

            <Button type='submit' variant='primary' className="mt-2"
            disabled={ isLoading }>
                Sign In
            </Button>

            { isLoading && <Loader /> }
        </Form> 

         <Row className='pt-3'>
          <Col>
            New Customer?{' '}
            <Link to={redirect ? `/register?redirect=${redirect}` : '/register'}>
              Register
            </Link>
          </Col>
        </Row>

        {/* Forgot password on a separate row */}
        <Row className='pb-3'>
          <Col>
            <Link to="/forgot-password">Forgot password?</Link>
          </Col>
        </Row>
        <Row className="pb-2">
        <Col><hr /></Col>
      </Row>
      <Row className="pb-3">
        <Col>
          <Button
            type="button"
            variant="outline-secondary"
            onClick={handleGuestCheckout}
          >
            Checkout as Guest
          </Button>
        </Col>
      </Row>
    </FormContainer>
  )
}

export default LoginScreen;